export default __webpack_public_path__ + "static/media/canine-III.19bee933.png";